// $(document).ready(function() {
//   var playlistItem = $('.contest-playlist .contest-playlist__item');
//   var playlistFirstItem =  $('.contest-playlist .contest-playlist__item:first');
//
//   playlistItem.removeClass('contest-playlist__item--active');
//
//   addCredencialsToVideoElement();
// });
//
// $(document).on('click', '.contest-playlist__item', function () {
//   var video = $(this).data('video');
//   var playlistItem = $('.contest-playlist .contest-playlist__item');
//
//   var PlaylistItemActive = $(this).hasClass('contest-playlist__item--active');
//
//   if (!PlaylistItemActive) {
//     var parent = $(this).parents('.contest-media');
//
//     parent.data('video-id', $(this).data('video-id'));
//     parent.find('.contest-player__title').html($(this).data('title'));
//     parent.find('.contest-player__category').html($(this).data('nomination'));
//     parent.find('.contest-player__person').html($(this).data('person'));
//     parent.find('.contest-player__likes .js-likes-counter').html($(this).data('likes-count'));
//     var liked = $(this).data('liked');
//     console.log(liked);
//     parent.find('.contest-player__likes .contest-like-count').removeClass('contest-like-count--active');
//     if (liked) {
//       parent.find('.contest-player__likes .contest-like-count').addClass('contest-like-count--active');
//     }
//
//     parent.find('.contest-player__title').attr('href', '/contest/video/' + $(this).data('video-id'));
//     parent.find('.contest-player__category').attr('href', '/contest/nomination/' + $(this).data('nomination-id'));
//     parent.find('.contest-player__person').attr('href', '/contest/author/' + $(this).data('author-id'));
//
//     playlistItem.removeClass('contest-playlist__item--active');
//     $(this).addClass('contest-playlist__item--active');
//
//     replaceVideo(this);
//   }
//
//   if($.fn.dotdotdot)
//   {
//     $(".ellipsis").dotdotdot({
//       tolerance: 5
//     });
//   }
// });

$('.js-contest-video-like-button').on('click', e => {
  let target = $(e.currentTarget);
  if (target.hasClass('detail-video-counter--active')) return;
  $.post('/ajax/likeContestVideo', {id: target.data('id')}, data => {
    target.addClass('detail-video-counter--active');
    let counter = parseInt(target.find('.detail-video-counter__number').html());
    target.find('.detail-video-counter__number').html(counter + 1);
  });
});

// function replaceVideo(source) {
//   var video = $(source).data('video');
//   video = $.parseHTML(video);
//   $('#contest-player__video').replaceWith(video[0]);
//   addCredencialsToVideoElement();
// }
//
// function addCredencialsToVideoElement() {
//   var element = $('.contest-media__player .contest-player iframe');
//   element.addClass('contest-player__video');
//   element.get(0).id = 'contest-player__video';
//
// }



// WEBPACK FOOTER //
// ./src/static/scripts/contest-video.js